module.exports = __webpack_public_path__ + "img/bottom.a3c2f8d9.jpg";